@if (column?.styleConfig?.type === 'multi-tag') {

  <div class="multi-tag-container">
    <ng-container *ngIf="value?.length > 0">
      @for (item of getTagItems(); track $index) {
        <div [ngClass]="'tag_' + ($index + 1)" [ngStyle]="getTagStyles($index)">
          {{ formatCellValue(getLabelValue(item), 'STRING') }}
        </div>
      }
    </ng-container>
    <div  *ngIf="value?.length > 3"
      class="tag_count"
      [appTooltip]="getTooltipData()"
      [keyToPick]="getLabelKey()"
      position="bottom">
      + {{ value.length -  3 }}
    </div>
  </div>

}
@else if (column?.styleConfig?.type === 'user-avatar') {
  <div class="user_badge">
    <div class="avatar_icon">{{ resolvedValue?.charAt(0) || "-" }}</div>
    {{ resolvedValue }}
  </div>

} @else if (column?.styleConfig?.type === 'action') {
  <button [ngClass]="getCellClasses()" [ngStyle]="getCellStyles()" *ngIf="evaluateButtonVisibility(column.styleConfig?.actionConfig)"
        (click)="handleButtonClick(column?.styleConfig?.actionConfig); $event.stopPropagation()" >
          <app-svg-icon
          *ngIf="effectiveConfig?.icon"
          class="icon right-icon"
          [path]="effectiveConfig?.icon"
          [ngStyle]="getIconStyles()">
        </app-svg-icon>
        {{ column.styleConfig?.actionConfig?.label }}
      </button>
} @else {

  <div class="cell" [ngClass]="getCellClasses()" [ngStyle]="getCellStyles()" (click)="handleClickableElement()">
    <app-svg-icon
      *ngIf="effectiveConfig?.icon && effectiveConfig?.iconPosition === 'left'"
      class="icon left-icon"
      [path]="effectiveConfig?.icon"
      [ngStyle]="getIconStyles()">
    </app-svg-icon>

    <span class="content">{{ resolvedValue || '-' }}</span>

    <app-svg-icon
    *ngIf="effectiveConfig?.icon && effectiveConfig?.iconPosition === 'right'"
    class="icon right-icon"
    [path]="effectiveConfig?.icon"
    [style.background]="effectiveConfig.iconColor || effectiveConfig.color">
    </app-svg-icon>
</div>

}


<!--} @else {
  <div *ngFor="let config of styleConfigForField" [ngClass]="config?.className" [ngStyle]="config?.style">
    <img *ngIf="config.iconPath" [src]="config?.iconPath" alt="icon">
    @if(record === config.value){
      {{ record }}
    }
  </div>
}-->
